import { ExactV2TransactionType } from './exact-v2-transaction-type';

/**
 * SQL fragments shared by the transactions and allocations queries, which must
 * agree on which agreement-holder payment rows are split per patient and on the
 * id each split carries. Both queries expect `agreement_holders` and
 * `cot_to_real_debtor` CTEs in scope.
 */
export class ExactV2HolderSplit {
  /**
   * Matches holder payment rows that fan out into one row per patient paid:
   * receipts, plus any other payment row with no CotGuid to follow.
   * `paymentCotAlias` is the payment's `cot_to_real_debtor` LEFT JOIN — a
   * correlated NOT EXISTS here defeats the planner's anti-join and rescans
   * the CTE per row.
   */
  static isSplitPayment(paymentAlias: string, paymentCotAlias: string): string {
    return `(
      ${paymentAlias}.debtorid IN (SELECT debtorid FROM agreement_holders)
      AND (
        ${paymentAlias}.trnstype = ${ExactV2TransactionType.Receipt}
        OR ${paymentCotAlias}.cot_guid IS NULL
      )
    )`;
  }

  /**
   * The `<paymentId>-<patientId>` id of a split, so allocations can point at
   * the split covering their charge rather than the undivided holder payment.
   */
  static splitId(paymentIdSql: string, patientIdSql: string): string {
    return `${paymentIdSql}::TEXT || '-' || ${patientIdSql}::TEXT`;
  }
}
